<template>
  <div id="memberAdmin">
    <h1>This is a member-admin page</h1>
  </div>
</template>

<script>
export default {
  name: 'MemberAdmin',
};
</script>
